import React, { useEffect, useState } from 'react'
import { ProductsShowcaseProps } from './types'
import './index.scss'

import { ProductCardWrapper } from '@/Components/ProductCardWrapper'
import { fetchProducts } from '@/Requests/getProducts'
import { ProductCardType } from '@petz/ds-card/dist/ProductCard/types'

import { createProductsArrayForSkeleton } from '@/Utils/generateProductForSkeleton'

export const ProductsShowcase: React.FC<ProductsShowcaseProps> = ({ urls }) => {
  const [products, setProducts] = useState<ProductCardType[]>([])
  const [showSkeleton, setShowSkeleton] = useState(true)
  let interval: NodeJS.Timeout

  function queryInterval() {
    interval = setInterval(function () {
      const elements = document.querySelectorAll(`.products-showcase ptz-card-price-section p`)

      if (elements.length == products.length) {
        setShowSkeleton(false)
      } else {
        interval = queryInterval()
      }
    }, 100)

    return interval
  }

  useEffect(() => {
    if (products.length === 0) return

    if (window.createCard == null) {
      setShowSkeleton(false)
    } else {
      interval = queryInterval()
    }
  }, [products])

  useEffect(() => {
    fetchProducts(...urls).then((data) => {
      setProducts(data)
    })
  }, [urls])

  const productsSkeleton = () => createProductsArrayForSkeleton(12).map((element, index) => <ProductCardWrapper size="lg" key={index} data={element} skeleton={true} />)

  const renderCards = () => {
    const size = window.innerWidth < 768 ? 'md' : 'lg'
    if (window.createCard != null) {
      return products.map((element) => {
        const productCardString = window.createCard ? window.createCard(element, { size: size }) : ''
        return <div className="monolith-card" key={element.id} dangerouslySetInnerHTML={{ __html: productCardString }} />
      })
    } else {
      return products.map((element) => <ProductCardWrapper size={size} key={element.sku} data={element} />)
    }
  }

  return (
    <div className={`products-showcase ${showSkeleton ? 'skeleton' : ''}`}>
      <div className="skeleton-carousel">{productsSkeleton()}</div>
      <div className="products-carousel">{renderCards()}</div>
    </div>
  )
}
